import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import { getAppAuditTrails } from '../services/api';

const actionColor = a => {
  if (!a) return '#8a9a97';
  if (a.includes('CREATE') || a.includes('REGISTER')) return '#A7F432';
  if (a.includes('UPDATE') || a.includes('VERIFY')) return '#4fc3f7';
  if (a.includes('DELETE') || a.includes('SUSPEND')) return '#ff4d4d';
  if (a.includes('PAYMENT') || a.includes('PAYOUT')) return '#f5a623';
  return '#8a9a97';
};

export default function AuditTrail({ toast }) {
  const { token } = useApp();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);

  const load = async (p=1) => {
    setLoading(true);
    try { const res = await getAppAuditTrails(token, { page:p, limit:20 }); setLogs(res.data||[]); setPagination(res.pagination||null); }
    catch(e) { toast?.(e.message,'error'); } finally { setLoading(false); }
  };

  useEffect(()=>{ load(); },[token]);

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total events</div><div className="stat-value">{pagination?.total??logs.length}</div><div className="stat-sub">All time</div></div>
        <div className="stat-card"><div className="stat-label">This page</div><div className="stat-value">{logs.length}</div><div className="stat-sub">Showing</div></div>
        <div className="stat-card"><div className="stat-label">Pages</div><div className="stat-value">{pagination?.totalPages??'—'}</div><div className="stat-sub">Total pages</div></div>
        <div className="stat-card"><div className="stat-label">Current page</div><div className="stat-value">{page}</div><div className="stat-sub">Page</div></div>
      </div>
      <div className="card" style={{ padding:0 }}>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Action</th><th>Actor</th><th>Entity</th><th>Description</th><th>Time</th></tr></thead>
            <tbody>
              {loading ? <tr><td colSpan={5} style={{ textAlign:'center', padding:40, color:'var(--text-dim)' }}>Loading audit trail…</td></tr>
              : logs.length===0 ? <tr><td colSpan={5} style={{ textAlign:'center', padding:40, color:'var(--text-dim)' }}>No audit logs found</td></tr>
              : logs.map((log,i)=>(
                <tr key={log.id||i}>
                  <td><span style={{ fontSize:11, fontWeight:600, color:actionColor(log.action), background:actionColor(log.action)+'22', padding:'2px 8px', borderRadius:20 }}>{log.action}</span></td>
                  <td style={{ fontSize:12 }}>{log.actorName||log.actor||'System'}</td>
                  <td style={{ fontSize:12 }}>{log.entityType||log.entity||'—'}</td>
                  <td style={{ fontSize:12, color:'var(--text-muted)', maxWidth:300, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{log.description||'—'}</td>
                  <td style={{ fontSize:11, color:'var(--text-dim)', whiteSpace:'nowrap' }}>{log.createdAt?new Date(log.createdAt).toLocaleString():'—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {pagination?.totalPages>1 && (
        <div style={{ display:'flex', gap:8, justifyContent:'center', marginTop:16 }}>
          <button className="btn btn-ghost" disabled={page<=1} onClick={()=>{setPage(p=>p-1);load(page-1);}}>← Prev</button>
          <span style={{ padding:'8px 14px', fontSize:13, color:'var(--text-muted)' }}>Page {page} / {pagination.totalPages}</span>
          <button className="btn btn-ghost" disabled={page>=pagination.totalPages} onClick={()=>{setPage(p=>p+1);load(page+1);}}>Next →</button>
        </div>
      )}
    </div>
  );
}
